import { CustomHandler } from "@crescentParts/Store/CustomHandlerCreator";
import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";

type HandlerType = CustomHandler<{pageHistory:string[]}>

export const DispatchPageHistory: HandlerType = props =>{
    props.dispatch({
        type:"Custom/PageHistory/addPage",
        pageHistory:props.parameter.pageHistory
    })
}

export const chain = [DispatchPageHistory];

const PageHistoryHandler = createHandlerChainRunner(chain,"PageHistory");
export default PageHistoryHandler;